import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { SkilljarHit } from '../algolia/components'

const SkilljarResults = ({ hit, clickCallback }: { hit: SkilljarHit, clickCallback: (hit: SkilljarHit) => void }) => {
  return (
    <div onClick={() => clickCallback(hit)} className='qa-topic-block thread-list-item topic-view forum-list-view-spacing thread-list-item--skilljar'>
      <span className='thread-list-item--index-label'>
        <Phrase m='Forum' p='federated.search.skilljar' />
      </span>
      <h4 className='thread-list-block__title'>
        <a className='qa-topic-title thread-list-block__title-link' href={hit.url} target='_blank'>{ hit.title }</a>
      </h4>
      <p className='thread-list-block__content qa-topic-content'>
        <a href={hit.url} target='_blank'>{ hit.content }</a>
      </p>
    </div>
  )
}

export default SkilljarResults
